import React from "react";
import SVG from "react-inlinesvg";
import {
  styledComponent,
  getVal,
  getValFromTheme,
} from "/app/src/higherOrderComponent";
import { Flex } from "/app/src/component";
import Modal from "react-responsive-modal";

class SVGButton extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showConfirmation: false,
    };
    this._onClick = this._onClick.bind(this);
  }

  _onClick(e) {
    e.stopPropagation();
    e.target.value = this.props.text;
    if (this.props.confirmationContent) {
      this.setState({ showConfirmation: true });
      return;
    }

    if (this.props.onClick) this.props.onClick(e);
  }

  render() {
    if (this.state.showConfirmation) {
      return (
        <Modal
          open={this.state.showConfirmation}
          showCloseIcon={true}
          onClose={() => {
            this.setState({ showConfirmation: false });
          }}
        >
          <Flex padding="15px" column center>
            {this.props.confirmationContent}
            <Flex>
              <Flex
                onClick={() => {
                  this.props.onClick();
                  this.setState({ showConfirmation: false });
                }}
                border="1px solid red"
                w="100px"
                center
                cursor="pointer"
              >
                Yes
              </Flex>
              <Flex w="20px" />
              <Flex
                border="1px solid black"
                w="100px"
                center
                cursor="pointer"
                onClick={() => {
                  this.setState({ showConfirmation: false });
                }}
              >
                Back
              </Flex>
            </Flex>
          </Flex>
        </Modal>
      );
    }
    if (this.props.disabled) {
      return (
        <Flex
          shrink={0}
          title={this.props.title}
          className={this.props.className}
          center
          color="lightgray"
        >
          {this.props.src && <SVG src={this.props.src} />}
          {this.props.text}
          {this.props.src && this.props.text && (
            <div style={{ width: "10px" }} />
          )}
        </Flex>
      );
    }

    return (
      <Flex
        shrink={0}
        title={this.props.title}
        className={this.props.className}
        cursor="pointer"
        center
        onClick={this._onClick}
      >
        {this.props.src && <SVG src={this.props.src} />}
        {this.props.text}
        {this.props.src && this.props.text && <div style={{ width: "10px" }} />}
      </Flex>
    );
  }
}

const StyledSVGButton = styledComponent(SVGButton, (props) => ({
  color: props.active
    ? getValFromTheme(props, ["hover"], props.theme.colors)
    : getValFromTheme(props, ["color"], props.theme.colors),
  "user-select": "none",
  direction: "ltr",
  "border-radius": "10px",
  border: props.border ? "3px solid" : undefined,
  ":hover >span>svg": {
    fill: getValFromTheme(props, ["hover"], props.theme.colors),
  },
  "> span": {
    height: getVal(props, ["h", "height"], "40px"),
    width: getVal(props, ["h", "height"], "40px"),
  },
  "> span > svg": {
    height: getVal(props, ["h", "height"], "100%"),
    width: getVal(props, ["h", "height"], "auto"),
    fill: props.active
      ? getValFromTheme(props, ["hover"], props.theme.colors)
      : getValFromTheme(props, ["color"], props.theme.colors),
    transform: "scale(0.7)",
  },
}));

export default StyledSVGButton;



// WEBPACK FOOTER //
// src/component/SVGButton/index.js